module.exports = __webpack_public_path__ + "9506ab939d483c630b7db236ce744665.svg";